import { useEffect, useState } from 'react';
import { Coins } from 'lucide-react';
import { useAuth } from './AuthModule';

const API = process.env.REACT_APP_API_URL || '';

function isCreditsNavRole(role) {
  return role === 'member' || role === 'tester' || role === 'admin';
}

export default function CreditsArea() {
  const { user } = useAuth();
  const [balance, setBalance] = useState(null);
  const canOpenCreditsPage = isCreditsNavRole(user?.role);

  useEffect(() => {
    if (!user?.id || !canOpenCreditsPage) {
      setBalance(null);
      return;
    }
    const userIdStr = String(user.id).replace(/n$/, '');
    fetch(`${API}/api/users/${userIdStr}/credits/balance`)
      .then((res) => (res.ok ? res.json() : { balance: 0 }))
      .then((data) => setBalance(data.balance != null ? Number(data.balance) : 0))
      .catch(() => setBalance(0));
  }, [user?.id, canOpenCreditsPage]);

  const baseClass = 'Menu-block Menu-block-credits CreditsArea';

  if (!canOpenCreditsPage) {
    return (
      <div
        className={`${baseClass} CreditsArea--plain`}
        aria-hidden="true"
      />
    );
  }

  const showBadge = balance != null && balance > 0;

  return (
    <a
      href="/kauppa"
      className={baseClass}
      aria-label={showBadge ? `Krediitit — ${balance} PC` : 'Krediitit'}
      title={showBadge ? `${balance} Pulina-krediittiä` : 'Krediitit'}
    >
      <Coins className="CreditsArea-icon" size={22} strokeWidth={2} aria-hidden />
      {showBadge && (
        <span className="CreditsArea-badge" aria-hidden>
          {balance}
        </span>
      )}
    </a>
  );
}
